import { render, staticRenderFns } from "./UVIndexYearly.vue?vue&type=template&id=68f78d12"
import script from "./UVIndexYearly.vue?vue&type=script&lang=js"
export * from "./UVIndexYearly.vue?vue&type=script&lang=js"
import style0 from "./UVIndexYearly.vue?vue&type=style&index=0&id=68f78d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports